module.exports = __webpack_public_path__ + "img/pagalfan.d85d0038.png";